import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
import AutoNumeric from 'autonumeric';
var LackForm = {
  init: function init() {
    var self = this;
    Base.app.popup.create({
      content: self.html(),
      on: {
        open: function open(popup) {
          self.onOpen(popup);
        }
      }
    }).open();
  },
  onOpen: function onOpen(popup) {
    var self = this;
    $(popup.el).find('#popup-dataline').submit(function (e) {
      self.newline(popup);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    $(popup.el).find('.submit-button').click(function () {
      self.submitOrder(popup);
    });
  },
  submitOrder: function () {
    var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(popup) {
      var self, rowCount, valid, codes, submitData, loading, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              rowCount = $(popup.el).find('table.data-input-table tbody').find('tr').length;

              if (!(rowCount == 0)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", false);

            case 4:
              valid = true;
              codes = [];
              submitData = [];
              $(popup.el).find('table.data-input-table tbody').find('tr').each(function (item, i) {
                var code = $(this).find('.code').text();
                var qty = $(this).find('.qty').text();
                var note = $(this).find('.note').text();
                var isDuplicatedCode = false;

                for (var ii = 0; ii < codes.length; ii++) {
                  if (codes[ii] == code) {
                    Base.app.dialog.alert('Có lỗi ở dòng thứ ' + (i + 1) + '. Mã sản phẩm ' + code + ' đã tồn tại phía trên');
                    isDuplicatedCode = true;
                    break;
                  }
                }

                if (isDuplicatedCode) {
                  valid = false;
                  return valid;
                }

                codes.push(code);
                submitData.push({
                  code: code,
                  qty: qty,
                  note: note
                });
                valid = true;
              });

              if (!(valid == false || codes.length == 0)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", false);

            case 10:
              loading = Base.app.dialog.preloader('Đang gửi đơn...');
              _context.next = 13;
              return Base.api('Donhangthieu', 'submitLackOrder', {
                data: submitData
              });

            case 13:
              rs = _context.sent;
              loading.close();

              if (!(rs.result == 'success')) {
                _context.next = 21;
                break;
              }

              Lack.onAdded(rs.rows);
              Utils.notiInfo('Đã gửi đơn thành công.');
              popup.close();
              _context.next = 23;
              break;

            case 21:
              Base.app.dialog.alert('Không kết nối được máy chủ. Liên hệ kỹ thuật viên để khắc phục.');
              return _context.abrupt("return", false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function submitOrder(_x) {
      return _submitOrder.apply(this, arguments);
    }

    return submitOrder;
  }(),
  newline: function () {
    var _newline = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(popup) {
      var self, dataRow, rs, code, qty, note, rowCount, tr, _tr;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = this;
              dataRow = $(popup.el).find('input[name=dataline]').val().trim();
              rs = Base.checkValidNewline(dataRow);

              if (rs) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", false);

            case 5:
              code = rs.code;
              qty = rs.qty;
              note = rs.note;

              if (Lack.editingID == 0) {
                // let loading = Base.app.dialog.preloader('Đang kiểm tra mã hàng...');
                // let rsCheckCode = await Base.api('Donhangdat','checkProductCode',{code});
                // loading.close();
                // if(rsCheckCode.result != 'success') {
                //   Base.app.dialog.alert(`Mã sản phẩm SP00${code} không tồn tại`);
                //   return false;
                // }
                rowCount = $(popup.el).find('table.data-input-table tbody').find('tr').length;
                tr = self.lineFormat({
                  rowCount: rowCount,
                  code: code,
                  qty: qty,
                  note: note
                });
                $(popup.el).find('table.data-input-table tbody').append(tr);
                $(popup.el).find('input[name=dataline]').val('');
                $(popup.el).find('table.data-input-table tbody tr:last-child a.remove').click(function (e) {
                  $(this).closest('tr').remove();
                  $(popup.el).find('table.data-input-table tbody').find('tr').each(function (item, i) {
                    $(this).find('td:first-child').text(i + 1);
                  });
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                });
                $(popup.el).find('table.data-input-table tbody tr:last-child').click(function (e) {
                  Lack.editingID = $(this).attr("row-id");
                  var code = $(this).find('.code').text();
                  var qty = $(this).find('.qty').text();
                  var note = $(this).find('.note').text();
                  $(popup.el).find('input[name=dataline]').val("".concat(code, ";").concat(qty, ";").concat(note));
                });
              } else {
                _tr = $(popup.el).find('table.data-input-table tbody tr[row-id="' + Lack.editingID + '"]');

                _tr.find('.code').text(code);

                _tr.find('.qty').text(qty);

                _tr.find('.note').text(note);

                Lack.editingID = 0;
                $(popup.el).find('input[name=dataline]').val('');
              }

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function newline(_x2) {
      return _newline.apply(this, arguments);
    }

    return newline;
  }(),
  lineFormat: function lineFormat(item) {
    return $("<tr row-id=\"".concat(item.rowCount + 1, "\">\n                  <td align=\"center\">").concat(item.rowCount + 1, "</td>\n                  <td class=\"code\">").concat(item.code, "</td>\n                  <td><div class=\"qty\">").concat(item.qty, "</div><div class=\"note\" style=\"font-size:10px; color:gray\">").concat(item.note, "</div></td>\n                  <td><a href=\"#\" class=\"color-red remove\"><i class=\"f7-icons icon\" style=\"font-size:15px;\">multiply_circle_fill</i></a></td>\n                </tr>"));
  },
  html: function html() {
    return "\n    <div class=\"popup lackform-popup\">\n      <div class=\"view\">\n        <div class=\"page\">\n          <div class=\"navbar\">\n            <div class=\"navbar-bg\"></div>\n            <div class=\"navbar-inner\">\n              <div class=\"left\"></div>\n              <div class=\"title\">Th\xEAm h\xE0ng k\xEA m\xE0 ch\u01B0a c\xF3</div>\n              <div class=\"right\">\n                <a href=\"#\" class=\"link popup-close\"><i class=\"icon f7-icons\">multiply</i></a>\n              </div>\n            </div>\n          </div>\n          <div class=\"toolbar toolbar-bottom\">\n            <a class=\"link submit-button\">L\u01AFU L\u1EA0I</a>\n          </div>\n          <div class=\"page-content\">\n            <div class=\"list no-hairlines no-margin\">\n              <ul>\n                <li>\n                  <div class=\"item-content item-input\">\n                    <div class=\"item-inner\">\n                      <div class=\"item-input-wrap\">\n                        <form id=\"popup-dataline\"><input type=\"text\" name=\"dataline\" style=\"font-size:smaller;\" placeholder=\"XXXX;1;Ghi ch\xFA (s\u1ED1 l\u01B0\u1EE3ng cho t\u1EEBng m\xE0u s\u1EAFc, model,...)\" /></form>\n                      </div>\n                    </div>\n                  </div>\n                </li>\n              </ul>\n            </div>\n            <div class=\"data-table\">\n              <table class=\"data-input-table\">\n                <thead>\n                  <tr>\n                    <th width=\"1%\">#</th>\n                    <th width=\"1%\">M\xE3</th>\n                    <th>SL</th>\n                    <th width=\"1%\"></th>\n                  </tr>\n                </thead>\n                <tbody>\n\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    ";
  }
};
var Lack = {
  pn: 'div[data-name=lack]',
  editingID: 0,
  $table: null,
  init: function init() {
    var self = this;
    self.$table = $(self.pn + ' table.table-list tbody');
    self.list();
    $(self.pn + " a.addnew-button").click(function () {
      LackForm.init();
    });
  },
  list: function () {
    var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var self, loading, rs;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              self = this;
              loading = Base.app.dialog.preloader('Đang tải danh sách');
              _context4.next = 4;
              return Base.api('Donhangthieu', 'list', {});

            case 4:
              rs = _context4.sent;
              loading.close();
              rs.rows.forEach(function (item, i) {
                self.$table.append(self.listitem(item));
              });
              self.$table.find('tr a.remove').click(function () {
                var $tr = $(this).closest('tr');
                Base.app.dialog.confirm('Bạn có chắc chắn xoá mã này khỏi danh sách?', 'Xác nhận', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var id, rs;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          id = $tr.attr("row-id");
                          $tr.remove();
                          _context3.next = 4;
                          return Base.api('Donhangthieu', 'remove', {
                            id: id
                          });

                        case 4:
                          rs = _context3.sent;

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
              });

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }(),
  listitem: function listitem(item) {
    var statusColor = item.status == null || Utils.str2Num(item.status) == 0 ? 'color-red' : 'color-green';
    return $("\n    <tr row-id=\"".concat(item.id, "\">\n      <td>\n        <div>").concat(item.code, " - ").concat(moment(item.created_date).format(Base.dateFormat), "</div>\n        <div>").concat(item.name ? item.name : '<i class="f7-icons icon color-orange" style="font-size:15px;">exclamationmark_triangle_fill</i> Mã hàng không tồn tại', "</div>\n        <div style=\"font-size:10px\">").concat(item.note, "</div>\n      </td>\n      <td>").concat(item.qty, "</td>\n      <td><i class=\"f7-icons icon ").concat(statusColor, "\" style=\"font-size:15px;\">dot_square_fill</i></td>\n      <td><a href=\"#\" class=\"color-red remove\"><i class=\"f7-icons icon\" style=\"font-size:15px;\">multiply_circle_fill</i></a></td>\n    </tr>"));
  },
  onAdded: function onAdded(items) {
    $(this.pn + ' table.table-list tbody').html('');
    this.list();
  }
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    Lack.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="lack">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Kê mà không có hàng</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="page-content">
      <div class="block">
         <a href="#" class="addnew-button"><i class="f7-icons icon" style="font-size:15px;">plus_circle_fill</i> Thêm mới</a>
      </div>
      <div class="data-table">
        <table class="data-input-table table-list">
          <thead>
            <tr>
              <th>Mã/Tên</th>
              <th>SL</th>
              <th></th>
              <th width="1%"></th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    </div>
  </div>
`
    }
    ;
});